import * as React from 'react';
import { newId } from '../fastflowUtils';
import './InputField.scss';

export interface IInputFieldProps {
  initialFocus?: boolean;
  validationErrorMessage?: any;
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  type?: string;
  maxLength?: number;
  validator?: (value: string) => boolean;
  validatorWhileTyping?: any;
  formSubmitted?: boolean;
  overrideValidationError?: boolean;
}

export default class InputField extends React.Component<
  IInputFieldProps,
  { showValidationError: boolean; id: number }
> {
  private inputRef: HTMLInputElement;

  constructor(props: IInputFieldProps) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);

    const { value, validator } = this.props;
    const showValidationError = value && validator ? !validator(value) : false;
    this.state = { showValidationError, id: undefined };
  }

  public componentWillMount() {
    this.setState({ id: newId() });
  }

  public focus() {
    this.inputRef.focus();
  }

  public render() {
    const {
      value,
      validator,
      disabled,
      validationErrorMessage,
      maxLength,
      initialFocus,
      placeholder,
      label,
      formSubmitted,
      overrideValidationError
    } = this.props;
    const isValid =
      (!validator || validator(value)) && !overrideValidationError;

    const showValidationCorrect = !disabled && isValid && validator;
    const showValidationError =
      !disabled &&
      (this.state.showValidationError ||
        (formSubmitted && !isValid) ||
        overrideValidationError);

    const validationErrorClass = showValidationError ? ' validationError' : '';
    const validationCorrectClass = showValidationCorrect
      ? '  validationCorrect'
      : '';
    const inputFieldId = `input_${this.state.id}`;
    const inputType = this.props.type ? this.props.type : 'text';
    return (
      <div
        className={
          'inputField form-group ' +
          validationErrorClass +
          validationCorrectClass
        }
      >
        <input
          id={inputFieldId}
          autoFocus={initialFocus}
          type={inputType}
          className="form-control"
          placeholder={placeholder}
          onChange={e => this.onChange(e)}
          onBlur={e => this.onBlur(e)}
          value={value}
          disabled={disabled}
          maxLength={maxLength}
          ref={c => (this.inputRef = c)}
        />
        <label htmlFor={inputFieldId}>
          {label}
          {showValidationError && (
            <span className="icon ion-information-circled" />
          )}
          {showValidationCorrect && (
            <span className="icon ion-checkmark-round" />
          )}
        </label>
        {showValidationError && (
          <div className="validationErrorMessage">{validationErrorMessage}</div>
        )}
      </div>
    );
  }

  private onChange(e: React.FormEvent<HTMLInputElement>) {
    const value = e.currentTarget.value;
    const { validator, validatorWhileTyping, formSubmitted } = this.props;
    const isValid = !validator || validator(value);
    if (isValid) {
      this.setState({ showValidationError: false });
    } else {
      if (formSubmitted) {
        this.setState({ showValidationError: true });
      } else if (validatorWhileTyping) {
        this.setState({ showValidationError: !validatorWhileTyping(value) });
      }
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  private onBlur(e: any) {
    const value = e.target.value;
    if (value) {
      const validator = this.props.validator;
      this.setState({ showValidationError: validator && !validator(value) });
    }

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/input-components/InputField.tsx